/**
 * 新建菜单
 */
import React from 'react';
import { Modal, Input, Form, Select, Radio, message } from 'antd';
import PropTypes from 'prop-types';
import styles from './CreateModal.module.scss';
import http from '@/assets/api/http';

const formItemLayout = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 4 },
    },
    wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 },
    },
};
const { Option } = Select;

class CreateModal extends React.Component {

    formRef = React.createRef();
    state = {
        confirmLoading: false,
        menuType: 'ONE_LEVEL',
        oneSelect: [],
        twoSelect: [],
        threeSelect: [],
        tabSelect: [],
        twoName: '',
        threeName: '',
        tabName: ''
    };

    componentDidMount() {
        this._getSelectFromParentID(0, 1);
    }

    /**
     * parentID 父级ID
     * level 当前层级
     */
    _getSelectFromParentID = (parentId, level) => {
        http('/?cmd=com.xqxc.api.pig.mis.biz.account.MenuMisService.listMenuInfoByParentId', { parentId, systemType: this.props.systemType }, 'POST').then((response) => {
            switch (level) {
                case 1:
                    this.setState({ oneSelect: response.result });
                    break;
                case 2:
                    this.setState({ twoSelect: response.result });
                    break;
                case 3:
                    this.setState({ threeSelect: response.result });
                    break;
                case 'tab':
                    this.setState({ tabSelect: response.result });
                    break;
            }
        }).catch((e) => {
            message.error(e.message);
        });
    }

    /**
     * level 当前层级
     */
    _cleanSelectFromLevel = (levelArr = []) => {
        for (let i = 0; i < levelArr.length; i++) {
            this._cleanSelect(levelArr[i]);
        }
    }

    /**
     * level 当前层级
     */
    _cleanSelect = (level) => {
        switch (level) {
            case 1:
                this.setState({ oneSelect: [] });
                break;
            case 2:
                this.setState({ twoSelect: [], twoName: '' });
                break;
            case 3:
                this.setState({ threeSelect: [], threeName: '' });
                break;
            case 'tab':
                this.setState({ tabSelect: [], tabName: '' });
                break;
        }
    }

    // 确认
    _handleOk = () => {
        this.formRef.current.validateFields().then((fieldsValue) => {
            console.log(fieldsValue);
            const { systemType } = this.props;
            const { menuType } = this.state;
            let data = { ...fieldsValue, systemType };
            data.menuName = data.menuName.trim();
            data.menuUrl = data.menuUrl.trim();
            data.menuCode = data.menuCode.trim();
            if (menuType == 'TWO_LEVEL') {
                data.parentId = fieldsValue.parentId.oneId;
            } else if (menuType == 'THREE_LEVEL') {
                data.parentId = fieldsValue.parentId.twoId;
                if (data.parentId == '') {
                    message.error('请选择二级菜单');
                    return;
                }
            } else if (menuType == 'TAB_PAGE') {
                if (fieldsValue.parentId.threeId) {
                    data.parentId = fieldsValue.parentId.threeId;
                } else if (fieldsValue.parentId.twoId) {
                    data.parentId = fieldsValue.parentId.twoId;
                } else if (fieldsValue.parentId.oneId) {
                    data.parentId = fieldsValue.parentId.oneId;
                }
                if (data.parentId == '') {
                    message.error('请选择父级菜单');
                    return;
                }
            } else if (menuType == 'BUTTON') {
                if (fieldsValue.parentId.tabId) {
                    data.parentId = fieldsValue.parentId.tabId;
                } else if (fieldsValue.parentId.threeId) {
                    data.parentId = fieldsValue.parentId.threeId;
                } else if (fieldsValue.parentId.twoId) {
                    data.parentId = fieldsValue.parentId.twoId;
                } else if (fieldsValue.parentId.oneId) {
                    data.parentId = fieldsValue.parentId.oneId;
                }
                if (data.parentId == '') {
                    message.error('请选择父级菜单');
                    return;
                }
            } else {
                data.parentId = 0;
            }

            http('/?cmd=com.xqxc.api.pig.mis.biz.account.MenuMisService.createMenuInfo', data, 'POST').then(() => {
                message.success('创建成功！');
                this.props.closeModal(true);
            }).catch((e) => {
                message.error(e.message);
            });
        });
    }

    // 取消
    _handleCancel = () => {
        this.props.closeModal();
    }

    // 渲染父级菜单下拉列
    _renderSelect = (list) => {
        return list.map((item) => {
            return <Option key={item.id} value={item.id}>{item.menuName}</Option>;
        });
    }

    // 单选发生变化
    _menuTypeChange = (e) => {
        this.setState({ menuType: e.target.value });
    }

    render() {
        const { confirmLoading, menuType, twoName, threeName, tabName, oneSelect, twoSelect, threeSelect, tabSelect } = this.state;

        return (
            <Modal
                width={900}
                centered
                title='新建菜单'
                visible={true}
                confirmLoading={confirmLoading}
                onOk={this._handleOk}
                onCancel={this._handleCancel}
                destroyOnClose={true}
                keyboard={true}
                maskClosable={false}
                cancelText='取消'
                okText='确认'
            >
                <div className={styles.container}>
                    <Form
                        {...formItemLayout}
                        ref={this.formRef}
                        initialValues={{
                            menuType: 'ONE_LEVEL',
                        }}
                        scrollToFirstError
                    >
                        <Form.Item
                            label="菜单类型"
                            name="menuType"
                            rules={[
                                { required: true },
                            ]}>
                            <Radio.Group onChange={this._menuTypeChange}>
                                <Radio key={0} value={'ONE_LEVEL'}>一级目录</Radio>
                                <Radio key={1} value={'TWO_LEVEL'}>二级菜单</Radio>
                                <Radio key={2} value={'THREE_LEVEL'}>三级菜单</Radio>
                                <Radio key={3} value={'TAB_PAGE'}>Tab标签页</Radio>
                                <Radio key={4} value={'BUTTON'}>按钮</Radio>
                            </Radio.Group>
                        </Form.Item>
                        {
                            menuType != 'ONE_LEVEL' ?
                                <Form.Item
                                    label="父级菜单"
                                    name="parentId"
                                    rules={[
                                        { required: true, message: '请选择父级菜单' },
                                    ]}>
                                    <div>
                                        <Select
                                            placeholder='请选择一级目录'
                                            style={{ width: 160 }}
                                            onChange={(value) => {
                                                let parentId = this.formRef.current.getFieldsValue().parentId;
                                                parentId = { ...parentId, oneId: value, twoId: '', threeId: '', tabId: '' };
                                                this.formRef.current.setFieldsValue({ parentId });
                                                this._getSelectFromParentID(value, 2);
                                                this._cleanSelectFromLevel([2, 3, 'tab']);
                                            }}
                                        >
                                            {this._renderSelect(oneSelect)}
                                        </Select>
                                        {menuType == 'BUTTON' || menuType == 'THREE_LEVEL' || menuType == 'TAB_PAGE' ? <Select
                                            value={twoName ? twoName : undefined}
                                            placeholder='请选择二级菜单'
                                            style={{ width: 160, marginLeft: 10 }}
                                            onChange={(value) => {
                                                let parentId = this.formRef.current.getFieldsValue().parentId;
                                                parentId = { ...parentId, twoId: value, threeId: '', tabId: '' };
                                                this.formRef.current.setFieldsValue({ parentId });
                                                this._getSelectFromParentID(value, 3);
                                                this._cleanSelectFromLevel([3, 'tab']);
                                            }}
                                        >
                                            {this._renderSelect(twoSelect)}
                                        </Select> : null}
                                        {menuType == 'BUTTON' || menuType == 'TAB_PAGE' ? <Select
                                            value={threeName ? threeName : undefined}
                                            placeholder='请选择三级菜单'
                                            style={{ width: 160, marginLeft: 10 }}
                                            onChange={(value) => {
                                                let parentId = this.formRef.current.getFieldsValue().parentId;
                                                parentId = { ...parentId, threeId: value, tabId: '' };
                                                this.formRef.current.setFieldsValue({ parentId });
                                                this._getSelectFromParentID(value, 'tab');
                                                this._cleanSelectFromLevel(['tab']);
                                            }}
                                        >
                                            {this._renderSelect(threeSelect)}
                                        </Select> : null}
                                        {menuType == 'BUTTON' ? <Select
                                            value={tabName ? tabName : undefined}
                                            placeholder='请选择Tab标签页'
                                            style={{ width: 160, marginLeft: 10 }}
                                            onChange={(value) => {
                                                let parentId = this.formRef.current.getFieldsValue().parentId;
                                                parentId = { ...parentId, tabId: value };
                                                this.formRef.current.setFieldsValue({ parentId });
                                            }}
                                        >
                                            {this._renderSelect(tabSelect)}
                                        </Select> : null}
                                    </div>
                                </Form.Item> : null
                        }
                        <Form.Item
                            label="菜单名称"
                            name="menuName"
                            rules={[
                                { required: true },
                                { max: 20, message: '最多可输入20个字' },
                            ]}>
                            <Input placeholder='请输入菜单名称' style={{ width: 320 }} />
                        </Form.Item>
                        <Form.Item
                            label="URL"
                            name="menuUrl"
                            rules={[
                                { required: true }
                            ]}>
                            <Input placeholder='请输入URL地址' style={{ width: 320 }} />
                        </Form.Item>
                        <Form.Item
                            label="编号"
                            name="menuCode"
                            rules={[
                                { required: true }
                            ]}>
                            <Input placeholder='请输入菜单编号' style={{ width: 320 }} />
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        );

    }
}

CreateModal.propTypes = {
    title: PropTypes.string, // 标题
    systemType: PropTypes.string, // 弹框入参
    closeModal: PropTypes.func.isRequired, // 关闭弹框的回调函数
};

export default CreateModal;
